import { batch } from 'react-redux';
import ReferencData from '../../../common/ShareFun/ReferencData';
import { fetchStates } from '../contactDetails';
import { retrieveVehicleEngineTypes } from '../inventory';
import { setRelocationPlanAlternateContact, setCaseTransfereeDetails, fetchRelocationPlanDependantDetails, fetchRelatedRoles } from './relocation';
import { RelocationBookmark } from '../../../../global';
import setContent from '../setContent';
import { cleanUpTravelDetails } from '../../../Components/ReLocationContent/TravelDetails/TravelDetailsHelper';

export const SET_SELECTED_BUNDLES_SERVICES = 'SET_SELECTED_BUNDLES_SERVICES';
export const SET_BUNDLES_SERVICES = 'SET_BUNDLES_SERVICES';
export const SET_TRAVEL_TYPES = 'SET_TRAVEL_TYPES';
export const SET_RELOCATION_PURPOSE = 'SET_RELOCATION_PURPOSE';
export const SET_TRAVEL_CLASS_TYPES = 'SET_TRAVEL_CLASS_TYPES';
export const SET_DIETARY_REQUIREMENT_TYPES = 'SET_DIETARY_REQUIREMENT_TYPES';
export const SET_RELOCATION_PLAN_TRAVEL_DETAILS = 'SET_RELOCATION_PLAN_TRAVEL_DETAILS';
export const UPDATE_TRAVEL_DETAILS_VALIDATION = 'UPDATE_TRAVEL_DETAILS_VALIDATION';
export const SET_VEHICLE_TYPES_WITH_CAN_TOW_AND_TOWABLE = 'SET_VEHICLE_TYPES_WITH_CAN_TOW_AND_TOWABLE';

export function updateTravelDetailsValidation(validation) {
    return setContent(UPDATE_TRAVEL_DETAILS_VALIDATION, validation)
}

export function updateTravelDetails(travelDetails) {
    return setContent(SET_RELOCATION_PLAN_TRAVEL_DETAILS, travelDetails)
}

/**
 * Fetch all necessary travel details data
 * Including belows:
 *      RetrieveSelectedBundlesAndServices
 *      RetrieveClientBundlesAndServices
 *      RetrieveTravelTypes
 *      RetrieveRelocationPurpose
 *      RetrieveTravelClassTypes
 *      RetrieveVehicleTypesWithCanTowAndTowable 
 *      RetrieveVehicleEngineTypes (inventory)
 *      RetrieveStatesOfCountry (contactDetails)
 * Above are from previous `getSelectData` method in travel component
 * 
 *      RetrieveRelocationPlanAlternateContact
 *      RetrieveTransfereeGeneralDetails (contactDetails)
 *      RetrieveRelocationPlanTravelDetails
 * Above are from previous `getTravelDetails` method in travel component
 * 
 *      RetrieveRelocationPlanDependantDetails
 * This is from source code, which was missing from the previous component
 */
export function fetchTravelDetailsData(casesId, inventory, relocationTravel, contactDetails, relocation) {
    // call api to store data
    return dispatch => {
        batch(() => {
            // fetch data unique to travel page at this moment
            dispatch(fetchSelectedBundlesAndServicesData(casesId, relocationTravel));
            dispatch(fetchBundlesAndServices(relocationTravel));
            dispatch(fetchTravelTypes(relocationTravel));
            dispatch(fetchRelocationPurpose(relocationTravel));
            dispatch(fetchTravelClassTypes(relocationTravel));
            dispatch(fetchDietaryRequirementTypes(relocationTravel));
            dispatch(fetchRelocationPlanTravelDetails(relocationTravel));
            dispatch(fetchVehicleTypesWithCanTowAndTowable(relocationTravel));
            // call state from contactDetails
            dispatch(fetchStates(contactDetails, 13));
            // call engineType from inventory 
            dispatch(retrieveVehicleEngineTypes(inventory));
            // call [relocationPlanAlternateContact], [castTransfereeDetails] from relocation
            // from the original source code
            // if (int.Parse(Session["ActiveAFRMax"].ToString()) <= (int)RelocationBookmark.Accommodation)
            if (sessionStorage.getItem('ActiveAFRMax') < RelocationBookmark.Accommodation) {
                dispatch(setRelocationPlanAlternateContact(relocation));
            }

            dispatch(setCaseTransfereeDetails(relocation));
            dispatch(fetchRelocationPlanDependantDetails(relocation));
            dispatch(fetchRelatedRoles(relocation));
        });
    }
}

// selectedBundlesAndServices
export function fetchSelectedBundlesAndServicesData(casesId, relocationTravel) {
    return dispatch => {
        if (relocationTravel.selectedBundleService.length === 0) {
            ReferencData.RetrieveSelectedBundlesAndServices(casesId)
                .then(res => {
                    if (res && res.Successful) {
                        dispatch(setContent(SET_SELECTED_BUNDLES_SERVICES, res.Bundles));
                    }
                });
        }
    }
}

// bundlesAndServices
export function fetchBundlesAndServices(relocationTravel) {
    return dispatch => {
        if (relocationTravel.bundlesAndServices.length === 0) {
            // get data from sessionStorage
            const clientServices = sessionStorage.getItem("ClientServices");
            ReferencData.RetrieveClientBundlesAndServices(clientServices)
                .then(res => {
                    if (res && res.Successful) {
                        dispatch(setContent(SET_BUNDLES_SERVICES, res.Bundles));
                    }
                });
        }
    }
}

// travelTypes
export function fetchTravelTypes(relocationTravel) {
    return dispatch => {
        if (relocationTravel.travelTypes.length === 0) {
            ReferencData.referenceDataService(null, "RetrieveTravelTypes")
                .then(res => {
                    dispatch(setContent(SET_TRAVEL_TYPES, res));
                });
        }
    }
}

// relocationPurpose
export function fetchRelocationPurpose(relocationTravel) {
    return dispatch => {
        if (relocationTravel.relocationPurpose.length === 0) {
            ReferencData.referenceDataService(null, "RetrieveRelocationPurpose")
                .then(res => {
                    dispatch(setContent(SET_RELOCATION_PURPOSE, res));
                });
        }
    }
}

// travelClassTypes
export function fetchTravelClassTypes(relocationTravel) {
    return dispatch => {
        if (relocationTravel.travelClassTypes.length === 0) {
            ReferencData.referenceDataService(null, "RetrieveTravelClassTypes")
                .then(res => {
                    dispatch(setContent(SET_TRAVEL_CLASS_TYPES, res));
                });
        }
    }
}

// dietaryRequirementTypes
export function fetchDietaryRequirementTypes(relocationTravel) {
    return dispatch => {
        if (relocationTravel.dietaryRequirementTypes.length === 0) {
            ReferencData.referenceDataService(null, "RetrieveDietaryRequirementTypes")
                .then(res => {
                    dispatch(setContent(SET_DIETARY_REQUIREMENT_TYPES, res));
                });
        }
    }
}

export function fetchRelocationPlanTravelDetails(relocationTravel, forceUpdate) {
    return dispatch => {
        if (Object.keys(relocationTravel.relocationPlanTravelDetails).length === 0 || forceUpdate) {
            const url = "api/OrderDetailService/RetrieveRelocationPlanTravelDetails";
            const relocationPlanId = sessionStorage.getItem("RelocationPlanId");
            return ReferencData.RetrieveRelocationPlanSteps(relocationPlanId, url)
                .then(res => {
                    if (res.RelocationPlanTravelDetails !== null) {
                        cleanUpTravelDetails(res);
                    }
                    dispatch(updateTravelDetails(res));
                    return res;
                })
        }
    }
}

// RetrieveVehicleTypesWithCanTowAndTowable
export function fetchVehicleTypesWithCanTowAndTowable(relocationTravel) {
    return dispatch => {
        if (relocationTravel.vehicleTypesWithCanTowAndTowable.length === 0) {
            ReferencData.referenceDataService(null, "RetrieveVehicleTypesWithCanTowAndTowable")
                .then(res => {
                    dispatch(setContent(SET_VEHICLE_TYPES_WITH_CAN_TOW_AND_TOWABLE, res));
                })
        }
    }
}